var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"inline-block"},attrs:{"data-adtest":_vm.$config.env !== 'production' ? 'on' : 'off',"data-ad-client":"ca-pub-7970843719346669","data-ad-slot":"3310655748"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }